<template>
    <div>
        <div style="padding: 0 20px">
            <div class="top">
                <div>
                    <el-input v-model="query.themeName"
                              placeholder="请输入自备良方名称搜索"
                              suffix-icon="el-icon-search"
                              style="width: 260px;margin-left: 20px"
                              size="small">
                    </el-input>
                </div>
                <div>
                    <el-button type="primary" @click="dialogAddVisible = true" style="width: 124px;">新增自备良方</el-button>
                </div>
            </div>

            <div>
                <el-table :data="tableData"
                          v-loading="loading"
                          :header-cell-style="{'padding-left': '10%'}"
                          :cell-style="{'padding-left': '10%'}">
                    <el-table-column prop="prescriptionName" label="自备良方名称"></el-table-column>
                    <el-table-column label="药材明细">
                        <template slot-scope="scope">
                            <div style="display: flex;flex-direction: row;width: 188px;flex-wrap:wrap;">
                                <div style="width: 94px!important;" v-for="item in  scope.row.doctorPrescriptionList">
                                    {{item.medicineName}}×{{item.count}}
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <el-button type="text" style="margin-right: 10px" @click="editPrescribe(scope.row)">编辑
                            </el-button>
                            <el-button type="text" class="delete-button" @click="deletePrescribe(scope.row)">删除
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pagination">
                <el-pagination
                        background
                        layout="total, prev, pager, next"
                        :current-page="pageNum"
                        :page-size="pageSize"
                        :total="total"
                        @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>

        <el-drawer title="新增自备良方" :visible.sync="dialogAddVisible" size="860px" :before-close="cancelAdd">
            <div class="drawer">
                <el-scrollbar style="height:100%">
                    <div style="padding: 20px 10px 0;">
                        <el-form :model="prescribeAdd" size="small" label-width="120px" ref="add" :rules="rule">
                            <div class="dialog-set">
                                <el-form-item label="自备良方名称:" prop="prescriptionName">
                                    <el-input v-model="prescribeAdd.prescriptionName" style="width: 282px"></el-input>
                                </el-form-item>
                            </div>
                            <el-form-item label="搜索药材:" prop="searchIngredients">
                                <el-autocomplete
                                        style="width: 282px;"
                                        suffix-icon="el-icon-search"
                                        size="small"
                                        class="inline-input mr20"
                                        v-model="searchIngredients"
                                        :fetch-suggestions="querySearch"
                                        placeholder="请输入药材名称进行搜索"
                                        :trigger-on-focus="false"
                                        @select="addSelect"
                                ></el-autocomplete>
                            </el-form-item>
                            <div style="padding: 0 20px">
                                <el-table :data="prescribeAdd.doctorPrescriptionList"
                                          :header-cell-style="{'padding-left': '8%'}"
                                          :cell-style="{'padding-left': '8%'}">
                                    <el-table-column prop="medicineName" label="药材名称"></el-table-column>
                                    <el-table-column :label="unitLabel">
                                        <template slot-scope="scope">
                                            <el-form :model="scope.row" :rules="rule" ref="add">
                                                <el-form-item prop="count">
                                                    <el-input style="width: 70px" size="small" v-model.number="scope.row.count"
                                                              　></el-input>
                                                </el-form-item>
                                            </el-form>
                                            <!--<el-input style="width: 70px" size="small" v-model="scope.row.count"  oninput="value=value.replace(/[^\d]/g,'')"></el-input>-->
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="count" label="数量"></el-table-column>
                                    <el-table-column label="操作">
                                        <template slot-scope="scope">
                                            <el-button type="text" class="delete-button"
                                                       @click="deleteIngredients(scope.$index)">删除
                                            </el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                        </el-form>
                    </div>

                </el-scrollbar>
            </div>
            <div class="dialog-foot-bottom">
                <el-button @click="cancelAdd" style="width: 76px">取消</el-button>
                <el-button type="primary" @click="confirmAdd" style="width: 76px">确定</el-button>
            </div>
        </el-drawer>
        <el-drawer title="编辑自备良方" :visible.sync="dialogEditVisible" size="860px">
            <div class="drawer">
                <el-scrollbar style="height:100%">
                    <div style="padding: 20px 10px 0;">
                        <el-form :model="prescribeEdit" size="small" label-width="120px" ref="edit" :rules="rule">
                            <div class="dialog-set">
                                <el-form-item label="自备良方名称:" prop="prescriptionName">
                                    <el-input v-model="prescribeEdit.prescriptionName" style="width: 282px"></el-input>
                                </el-form-item>
                            </div>

                            <el-form-item label="搜索药材:" prop="searchIngredients">
                                <el-autocomplete
                                        style="width: 282px;"
                                        suffix-icon="el-icon-search"
                                        size="small"
                                        class="inline-input mr20"
                                        v-model="searchIngredients"
                                        :fetch-suggestions="querySearch"
                                        placeholder="请输入药材名称进行搜索"
                                        :trigger-on-focus="false"
                                        @select="editSelect"
                                ></el-autocomplete>
                            </el-form-item>
                            <div style="padding: 0 20px">
                                <el-table :data="prescribeEdit.doctorPrescriptionList"
                                          :header-cell-style="{'padding-left': '8%'}"
                                          :cell-style="{'padding-left': '8%'}">
                                    <el-table-column prop="medicineName" label="药材名称"></el-table-column>
                                    <el-table-column :label="unitLabel">
                                        <template slot-scope="scope">
                                            <el-form :model="scope.row" :rules="rule" ref="edit">
                                                <el-form-item prop="count">
                                                    <el-input type="number" style="width: 100px" @keydown="handleInput" size="small" v-model.number="scope.row.count"
                                                              　></el-input>
                                                </el-form-item>
                                            </el-form>
                                            <!--<el-input style="width: 70px" size="small" v-model="scope.row.count"  oninput="value=value.replace(/[^\d]/g,'')"></el-input>-->
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="操作">
                                        <template slot-scope="scope">
                                            <el-button type="text" class="delete-button"
                                                       @click="editDeleteIngredients(scope.$index)">删除
                                            </el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                        </el-form>
                    </div>
                </el-scrollbar>
            </div>
            <div class="dialog-foot-bottom">
                <el-button @click="dialogEditVisible = false" style="width: 76px">取消</el-button>
                <el-button type="primary" @click="confirmEdit" style="width: 76px">确定</el-button>
            </div>
        </el-drawer>
    </div>
</template>

<script>
    const isNum = (rule, value, callback) => {
        const age = /^[0-9]*$/
        if (!age.test(value)) {
            callback(new Error('只能为数字'))
        } else {
            callback()
        }
    }
    export default {
        data: function () {
            return {
                unitLabel: '剂量(克)',
                authorization: localStorage.getItem('authorization'),
                // 表格信息
                query: {
                    themeName: '',
                },
                bookList: [],
                loading: true,
                tableData: [],
                // 分页信息
                pageNum: 1,
                pageSize: 10,
                total: 0,
                dosageUnit: '剂量(克)',
                // 弹窗开关
                dialogAddVisible: false,
                dialogEditVisible: false,
                // 药材数据
                medicineList: [],
                searchIngredients: '',
                // 新增处方数据
                prescribeAdd:  {
                    id:'',
                    medicinalMaterialsType: 0,
                    prescriptionName: '',
                    doctorPrescriptionList: []
                },
                rule: {
                    prescriptionName: [{required: true, message: '请输入自备良方名称', trigger: 'blur'}],
                    count:[{required:false, validator: isNum, trigger: 'blur' , message: '请输入药品剂量'}]
                },
                // 编辑处方数据
                prescribeEdit: {
                    id:'',
                    medicinalMaterialsType: 0,
                    prescriptionName: '',
                    doctorPrescriptionList: []
                },
            }
        },
        methods: {
            handleInput(e) {
                let a = e.key.replace(/[^\d]/g, "");
                if (!a) {
                    e.preventDefault();
                }
            }
,
            // 获取自备良方列表
            getData() {
                this.loading = true

                let params = new FormData()
                params.append('name', this.query.themeName)
                params.append('currentPage', this.pageNum)
                params.append('pageSize', 10)
                this.axios.post('/api-b/10005/queryDoctorPrescription/', params, {
                    headers: {
                        Authorization: this.authorization,
                    }
                }).then(res => {
                    console.log(res.data)
                    if (res.data.code === 10000) {
                        if (res.data.data.data.length !== 0) {
                            this.tableData =  res.data.data.data
                        } else {
                            this.$message.info('暂无自备良方')
                            this.tableData = []
                        }
                        this.total = res.data.data.totalCount
                    } else {
                        this.$message.error(res.data.message)
                        this.tableData = []
                        this.total = 0
                    }
                    this.loading = false
                }).catch(error => {
                    this.tableData = []
                    this.total = 0
                    this.loading = false
                })
            },
            // 表格换页
            handlePageChange(val) {
                this.pageNum = val;
                this.getData();
            },
            // 弹窗列表更换克袋
            selectUnit(val) {
                if (val === 'KE') {
                    this.dosageUnit = '剂量(克)'
                } else if (val === 'DAI') {
                    this.dosageUnit = '剂量(袋)'
                }
            },
            // 搜索药材提示
            querySearch(queryString, cb) {
                let params = new FormData()
                params.append('medicinalName', this.searchIngredients)
                params.append('pharmacyId', 0)
                params.append('typeCode', 'KE_LI')
                params.append('currentPage', 1)
                params.append('pageSize', 10)
                this.axios.post('api-b/10005/queryMedicinalMaterialsDisNew', params, {
                    headers: {
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        if (res.data.data.data !== 0) {
                            this.medicineList = []
                            for (let i = 0; i < res.data.data.data.length; i++) {
                                this.medicineList[i] = {
                                    value: res.data.data.data[i].medicinalName,
                                    medicinalName: res.data.data.data[i].medicinalName
                                }
                            }

                        } else {
                            this.$message.info('暂无药材')
                            this.medicineList = []
                        }
                    } else {
                        this.$message.error(res.data.message)
                        this.medicineList = []
                    }
                    cb(this.medicineList);
                })
            },
            // 新增弹窗新增药材
            addSelect(item) {
                let medicine = {
                    medicineName: item.medicinalName,
                    count: '',
                }
                for (let i of this.prescribeAdd.doctorPrescriptionList) {
                    if (i.medicineName === item.medicinalName) {
                        this.$message.info("请勿重复添加")
                        this.searchIngredients = ''
                        return
                    }
                }
                this.prescribeAdd.doctorPrescriptionList.push(medicine)
                this.searchIngredients = ''
            },
            // 新增弹窗删除药材
            deleteIngredients(index) {
                this.prescribeAdd.list.splice(index, 1)
            },
            // 关闭弹窗消除验证
            cancelAdd() {
                this.dialogAddVisible = false
                this.$nextTick(() => {
                    this.$refs.add.resetFields()
                })
                this.searchIngredients = ''
                this.prescribeAdd.doctorPrescriptionList = []
            },
            // 确认添加
            confirmAdd() {
                this.$refs.add.validate(valid => {
                    if (valid) {
                        this.axios.post('/api-b/10036/100124', this.prescribeAdd, {
                            headers: {
                                Authorization: this.authorization
                            }
                        }).then(res => {
                            if (res.data.code === 10000) {
                                this.$message.success(res.data.message)
                                this.dialogAddVisible = false
                                this.getData()
                                this.$nextTick(() => {
                                    this.$refs.add.resetFields()
                                    this.prescribeAdd.doctorPrescriptionList = []
                                    this.searchIngredients = ''
                                })
                            } else {
                                this.$message.error(res.data.message)
                            }
                        })
                    } else {
                        this.$message.error('请按照要求正确填写相关信息')
                    }
                })
            },

            // 编辑弹窗按钮
            editPrescribe(data) {
                this.prescribeEdit = JSON.parse(JSON.stringify(data))
                this.searchIngredients = ''
                this.dialogEditVisible = true
            },
            // 编辑弹窗增加药材
            editSelect(item) {
                let medicine = {
                    medicineName: item.medicinalName,
                    count: '',
                }

                this.prescribeEdit.doctorPrescriptionList.push(medicine)
                console.log(this.prescribeEdit.doctorPrescriptionList)
            },
            // 编辑弹窗删除药材
            editDeleteIngredients(index) {
                this.prescribeEdit.doctorPrescriptionList.splice(index, 1)
            },
            // 确认修改
            confirmEdit() {
                this.$refs.edit.validate(valid => {
                    if (valid) {
                        this.axios.post('/api-b/10036/100123', this.prescribeEdit, {
                            headers: {
                                Authorization: this.authorization
                            }
                        }).then(res => {
                            if (res.data.code === 10000) {
                                this.$message.success(res.data.message)
                                this.dialogEditVisible = false
                                this.getData()
                            } else {
                                this.$message.error(res.data.message)
                            }
                        })
                    } else {
                        this.$message.error('请按照要求正确填写相关信息')
                    }
                })
            },
            // 删除处方
            deletePrescribe(data) {
                let params = new FormData()
                params.append('doctorPrescriptionId', data.id)
                this.axios.post('/api-b/10036/100125/', params, {
                    headers: {
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.getData()
                        this.$message.success(res.data.message)
                    } else {
                        this.$message.error((res.data.message))
                    }
                })
            }
        },
        watch: {
            query: {
                handler() {
                    this.pageNum = 1
                    setTimeout(() => {
                        this.getData()
                    }, 300)
                },
                deep: true
            }
        },
        created() {
            this.getData()
        }
    }
</script>

<style>
    :focus {
        outline: none;
    }

    .el-drawer__header > :first-child {
        margin-top: -20px;
    }

    .el-drawer__header {
        height: 34px;
        background: rgba(97, 167, 255, 1);
        margin-bottom: 0;
        color: #FFFFFF;
        font-size: 14px;
    }

    .el-drawer__close-btn {
        margin-top: -20px;
        color: #FFFFFF;
        font-size: 14px;
    }

    .el-scrollbar {
        padding-bottom: 20px;
    }

    body .el-scrollbar__wrap {
        overflow-x: hidden;
        margin-bottom: 20px;
    }

    .add-dialog {
        margin: 0 !important;
        position: absolute;
        right: 0;
        top: 0;
        min-width: 900px !important;
        min-height: 100%;
        display: flex;
        flex-direction: column;
        max-height: calc(100% - 30px);
        max-width: calc(100% - 30px);
    }

    .el-dialog__body {
        transform: translate3d(0, 0, 0);
        overflow: auto;
    }

    .dialog-foot-bottom {
        position: absolute;
        bottom: 20px;
        right: 20px;
    }

    .el-radio {
        margin-right: 20px;
    }
</style>
<style scoped>
    .top {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-top: 12px;
        height: 52px;
    }

    .dialog-set {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
    }

    .drawer {
        height: 861px;
        border-bottom: 1px solid rgba(227, 227, 227, 1);
    }

    .dialog-foot-bottom {
        position: absolute;
        bottom: 13px;
        right: 20px;
    }

    .delete-button {
        color: rgba(255, 75, 75, 1) !important;
    }

    .delete-button:hover {
        color: rgba(255, 75, 75, 0.8) !important;
    }

    .delete-button:focus {
        color: rgba(215, 37, 41, 1) !important;
    }
</style>